const API_URL = process.env.REACT_APP_API_URL;

class S3 {
  constructor() {}

  async _genericCall(method, params) {
    const res = await fetch(API_URL, {
      method: 'POST',
      body: JSON.stringify({ action: 's3_operation', method, params })
    });
    const data = await res.json();
    if (data.error) throw new Error(data.error);

    if (data.Contents) {
      data.Contents.forEach(item => {
        if (item.LastModified) {
          item.LastModified = new Date(item.LastModified);
        }
      });
    }

    return data;
  }

  listObjectsV2(params) {
    return { promise: () => this._genericCall('listObjectsV2', params) };
  }

  listObjects(params) {
    return { promise: () => this._genericCall('listObjects', params) };
  }

  deleteObject(params) {
    return { promise: () => this._genericCall('deleteObject', params) };
  }

  getObjectTagging(params, callback) {
    this._genericCall('getObjectTagging', params)
      .then(data => callback(data.error ? data : null, data))
      .catch(err => callback(err));
  }

  putObjectTagging(params, callback) {
    this._genericCall('putObjectTagging', params)
      .then(data => callback(data.error ? data : null, data))
      .catch(err => callback(err));
  }

  _uploadWithProgress(params) {
    let xhr = new XMLHttpRequest();
    let onProgressCallback = () => {};
    
    const requestObj = {
      on: (event, callback) => {
        if (event === 'httpUploadProgress') {
          onProgressCallback = callback;
        }
        return requestObj;
      },
      send: (callback) => {
        fetch(API_URL, {
          method: 'POST',
          body: JSON.stringify({ action: 's3_presigned_url', files: [{key: params.Key, contentType: params.ContentType, bucket: params.Bucket}] })
        }).then(r => r.json()).then(urlData => {
          xhr.upload.onprogress = (progressEvent) => {
            if (progressEvent.lengthComputable) {
              onProgressCallback({ loaded: progressEvent.loaded, total: progressEvent.total });
            }
          };
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              if(callback) callback(null, {});
            } else {
              if(callback) callback(new Error(xhr.statusText));
            }
          };
          xhr.onerror = () => { if(callback) callback(new Error("Network Error")); };
          xhr.onabort = () => {
            const err = new Error('RequestAbortedError');
            err.code = 'RequestAbortedError';
            if(callback) callback(err);
          };
          xhr.open('PUT', urlData.urls[0].url, true);
          xhr.setRequestHeader('Content-Type', params.ContentType || '');
          if (params.ACL) {
            xhr.setRequestHeader('x-amz-acl', params.ACL);
          }
          xhr.send(params.Body);
        }).catch(err => {
          if(callback) callback(err);
        });
      },
      promise: () => new Promise((resolve, reject) => {
        requestObj.send((err, data) => {
          if (err) reject(err); else resolve(data);
        });
      }),
      abort: () => { xhr.abort(); }
    };
    return requestObj;
  }

  putObject(params) {
    return this._uploadWithProgress(params);
  }

  upload(params) {
    return this._uploadWithProgress(params);
  }
}

class DynamoDBDocumentClient {
  async _genericCall(method, params, callback) {
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        body: JSON.stringify({ action: 'dynamodb_operation', method, params })
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      if (callback) callback(null, data);
      return data;
    } catch (err) {
      if (callback) callback(err);
      throw err;
    }
  }

  scan(params, callback) {
    const p = this._genericCall('scan', params, callback);
    return { promise: () => p };
  }
  get(params, callback) {
    const p = this._genericCall('get', params, callback);
    return { promise: () => p };
  }
  put(params, callback) {
    const p = this._genericCall('put', params, callback);
    return { promise: () => p };
  }
  update(params, callback) {
    const p = this._genericCall('update', params, callback);
    return { promise: () => p };
  }
  delete(params, callback) {
    const p = this._genericCall('delete', params, callback);
    return { promise: () => p };
  }
}

class SES {
  sendEmail(params) {
    return {
      promise: async () => {
        const res = await fetch(API_URL, { method: 'POST', body: JSON.stringify({ action: 'ses_sendEmail', params }) });
        const data = await res.json();
        if (data.error) throw new Error(data.error);
        return data;
      }
    };
  }
}

class CognitoIdentityServiceProvider {
  async _genericCall(method, params) {
    const res = await fetch(API_URL, { method: 'POST', body: JSON.stringify({ action: 'cognito_operation', method, params }) });
    const data = await res.json();
    if (data.error) throw new Error(data.error);
    return data;
  }
  adminSetUserMFAPreference(params) {
    return { promise: () => this._genericCall('adminSetUserMFAPreference', params) };
  }
  adminUpdateUserAttributes(params) {
    return { promise: () => this._genericCall('adminUpdateUserAttributes', params) };
  }
}

const AWS = {
  config: { update: () => {} },
  S3,
  DynamoDB: { DocumentClient: DynamoDBDocumentClient },
  SES,
  CognitoIdentityServiceProvider,
  Credentials: class {}
};

export default AWS;
